/**
 * <s-video-loop> — skips a lead-in (e.g. a black opening) on a looping background video.
 *
 * Expected DOM:
 *   <s-video-loop data-start="0.5">
 *     <video src="..." autoplay loop muted playsinline></video>
 *   </s-video-loop>
 *
 * The video keeps native `loop`, so it plays even if this script never runs. This element
 * only jumps past `data-start` seconds when playback is before that point (initial play and
 * every time the loop wraps back to 0).
 */
class SVideoLoop extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector("video");
    if (!this.video) return;

    this.start = parseFloat(this.dataset.start) || 0;

    this.skipLeadIn = () => {
      const { duration, currentTime } = this.video;
      if (!this.start || (duration && this.start >= duration)) return;
      if (currentTime < this.start) this.video.currentTime = this.start;
    };

    this.video.addEventListener("loadedmetadata", this.skipLeadIn);
    this.video.addEventListener("timeupdate", this.skipLeadIn);
    if (this.video.readyState >= 1) this.skipLeadIn();
  }

  disconnectedCallback() {
    this.video?.removeEventListener("loadedmetadata", this.skipLeadIn);
    this.video?.removeEventListener("timeupdate", this.skipLeadIn);
  }
}

if (!customElements.get("s-video-loop")) {
  customElements.define("s-video-loop", SVideoLoop);
}
